/**
 * Guide d'installation iOS — Apple n'expose aucune API d'installation PWA :
 * impossible d'installer en 1 tap comme sur Android. On affiche donc les
 * 3 gestes à faire dans Safari, en gros et illustrés (cible terrain).
 */

import { Modal } from "@champ-erp/ui";
import { Share, SquarePlus } from "lucide-react";

export interface GuideInstallationIosProps {
  open: boolean;
  onClose: () => void;
}

export function GuideInstallationIos({ open, onClose }: GuideInstallationIosProps) {
  return (
    <Modal open={open} onClose={onClose} title="Installer Crayéa sur votre iPhone" size="sm">
      <ol className="space-y-4 text-sm text-champagne-900">
        <li className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-champagne-200 text-[13px] font-semibold text-champagne-800">
            1
          </span>
          <span>
            Ouvrez ce site dans <strong>Safari</strong> (l'installation ne marche pas depuis une
            autre app).
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-champagne-200 text-[13px] font-semibold text-champagne-800">
            2
          </span>
          <span className="flex-1">
            Touchez le bouton <strong>Partager</strong>{" "}
            <Share size={16} className="inline text-champagne-700" aria-hidden="true" /> en bas de
            l'écran.
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-champagne-200 text-[13px] font-semibold text-champagne-800">
            3
          </span>
          <span className="flex-1">
            Faites défiler et touchez <strong>« Sur l'écran d'accueil »</strong>{" "}
            <SquarePlus size={16} className="inline text-champagne-700" aria-hidden="true" /> puis{" "}
            <strong>Ajouter</strong>.
          </span>
        </li>
      </ol>
      <p className="mt-5 text-xs text-champagne-700">
        L'icône Crayéa apparaît sur votre écran d'accueil : l'app s'ouvre en plein écran, comme une
        application classique.
      </p>
    </Modal>
  );
}
